import { TranscodingStatuses } from '../constants/transcoding-statuses';
import { eventsList } from '../events/list';
import { emit } from '../events/notifier';
const POLLING_TIMEOUT = 60 * 1000;
export function initPolling(settings, adapter, itemMapper, http, _temp) {
  let {
    path = '/files'
  } = _temp === void 0 ? {} : _temp;
  return function (itemId) {
    function emitItemUpdateEvent(result) {
      const event = emit(adapter, eventsList.ITEM.UPDATE, {
        arguments: [result.data, result.data]
      });
      event.resolve(result);
    }
    return new Promise(function (resolve, reject) {
      function checkItemStatus() {
        setTimeout(function () {
          http.get(`${settings.apiUrl}${path}/${itemId}`, null, {
            cache: false
          }).then(function (response) {
            const status = response.data.op_status;
            if (status === TranscodingStatuses.READY) {
              const responseItemId = response.data.file_name;
              adapter.item.get(responseItemId).then(emitItemUpdateEvent);
              resolve(responseItemId);
              return;
            }
            const result = itemMapper(response.data, settings, {}, true);
            emitItemUpdateEvent({
              data: result
            });
            if (status === TranscodingStatuses.FAILED) {
              reject('Item transcoding failed');
              return;
            }
            checkItemStatus();
          }).catch(checkItemStatus);
        }, POLLING_TIMEOUT);
      }
      checkItemStatus();
    });
  };
}